// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","loaderContainer":"Loader_loaderContainer__OZWYk","fullScreen":"Loader_fullScreen__qU8Rk","dot":"Loader_dot__8Tb8I","slide":"Loader_slide__ixIe8"};